export default function Loading() {
    return (
      <div className="fallback-loading">
        <div className="spinner" />
        <p>Loading...</p>

      </div>
    );
  }
  